// NextJS requires that data passed from server to client be serialisable.
// This includes state in Redux, since we use next-redux-wrapper to pass this data from server to client.
// Alternative approaches and information here: https://github.com/vercel/next.js/issues/11993
// @ts-expect-error - Automatic, Please fix when editing this file
const makeErrorSerialisable = (error) => JSON.parse(JSON.stringify(error));

export default makeErrorSerialisable;
